import React, { useEffect, useState, useCallback } from 'react';
import LoadingButton from '../LoadingButton';
import { useDispatch, useSelector } from 'react-redux';
import {
   ExaminationActions,
   selectExaminationEligibilityReportSent,
   ExaminationTypes,
} from 'State/Redux/ExaminationRedux';
import { selectContact } from 'State/Redux/ContactRedux';
import { toast } from 'react-toastify';
import {
   selectIsLoading,
   AsyncActions,
   selectIsError,
} from 'State/Redux/AsyncRedux';
import { isEnterKeyPress } from 'Util/Helpers/Input';

const SendReportToAspeqButton = (): JSX.Element => {
   const dispatch = useDispatch();
   const contact = useSelector(selectContact);
   const examinationEligibilityReportSent = useSelector(
      selectExaminationEligibilityReportSent
   );
   const isSendingEmail = useSelector(
      selectIsLoading([
         ExaminationTypes.SEND_EXAMINATION_ELIGIBILITY_REPORT_ASPEQ_REQUEST,
      ])
   );
   const isSentEmailError = useSelector(
      selectIsError([
         ExaminationTypes.SEND_EXAMINATION_ELIGIBILITY_REPORT_ASPEQ_REQUEST,
      ])
   );

   const [sendEmailPressed, setSendEmailPressed] = useState<boolean>(false);

   const resetState = useCallback(() => {
      setSendEmailPressed(false);

      dispatch(
         AsyncActions.resetAsync([
            ExaminationTypes.SEND_EXAMINATION_ELIGIBILITY_REPORT_USER_REQUEST,
         ])
      );
      dispatch(ExaminationActions.resetExaminationEligibilityReportSentState());
   }, [setSendEmailPressed, dispatch]);

   useEffect((): void => {
      if (!isSendingEmail && sendEmailPressed) {
         if (examinationEligibilityReportSent) {
            toast.success(`Successfully Sent Email to Aspeq`);
            resetState();
         } else if (isSentEmailError) {
            toast.error(
               `Email could not be sent to Aspeq. Please try again later.`
            );
            resetState();
         }
      }
   }, [
      resetState,
      isSendingEmail,
      isSentEmailError,
      examinationEligibilityReportSent,
      sendEmailPressed,
   ]);

   return (
      <LoadingButton
         flat
         primary
         onClick={(): void => {
            dispatch(
               ExaminationActions.resetExaminationEligibilityReportSentState()
            );
            dispatch(
               ExaminationActions.sendExaminationEligibilityReportAspeqRequest(
                  contact.contactId.toString()
               )
            );
            setSendEmailPressed(true);
         }}
         onKeyUp={(keyPress): void => {
            if (!isEnterKeyPress(keyPress)) return;
            dispatch(
               ExaminationActions.resetExaminationEligibilityReportSentState()
            );
            dispatch(
               ExaminationActions.sendExaminationEligibilityReportAspeqRequest(
                  contact.contactId.toString()
               )
            );
            setSendEmailPressed(true);
         }}
         isLoading={isSendingEmail}
      >
         Send to Aspeq
      </LoadingButton>
   );
};

export default React.memo(SendReportToAspeqButton);
